import React from "react";
function FlatTitle() {
    return (
        <>
            {/* <!-- flat-title --> */}
            <section class="flat-spacing-9">
                <div class="container">
                    <div class="flat-title my-0">
                        <span class="title">We are Ecomus</span>
                        <p class="sub-title text_black-2">
                            Welcome to our classic women's clothing store, where we believe <br class="d-xl-block d-none" />
                            that timeless style never goes out of fashion. Our collection features classic <br class="d-xl-block d-none" />
                            pieces that are both stylish and versatile, perfect for building a <br class="d-xl-block d-none" />
                            wardrobe that will last for years.
                        </p>
                    </div>
                </div>
            </section>

        </>
    )
}
export default FlatTitle;